import { IScaleV1 } from '../tools/api.service';
import { Injectable } from "@angular/core";

@Injectable()
export class Scale {
    code:string;
    serialNumber:string;

    public static parseToScale(item: Scale): IScaleV1 {
        let result = new IScaleV1();
        result.code = item.code;
        result.serialNumber = item.serialNumber;
        return result;
    }
}